<div class="align-right">
  <button mat-button color="primary" *ngIf="origin" (click)="backToReportCycle()">
    <mat-icon>arrow_back_ios</mat-icon>
    <span>Back to report cycle wizard</span>
  </button>
  <button mat-button color="primary" (click)="add()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="list" matSort>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "global.code" | translate }} </th>
      <td mat-cell *matCellDef="let item"> {{item.code}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "global.description" | translate }} </th>
      <td mat-cell *matCellDef="let item"> {{item.description}} </td>
    </ng-container>

    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "global.comment" | translate }} </th>
      <td mat-cell *matCellDef="let item"> {{item.comment}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <!--        <mat-icon (click)="edit(item)"  color="primary">edit</mat-icon>-->

        <button mat-icon-button color="primary" (click)="edit(item)" matTooltip="Edit" matTooltipPosition="above">
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="!item.disabled" mat-icon-button color="primary" (click)="updateDisabled(item, true)"
                matTooltip="Disable" matTooltipPosition="above">
          <mat-icon>check_circle</mat-icon>
        </button>
        <button *ngIf="item?.disabled" mat-icon-button color="primary" (click)="updateDisabled(item, false)"
                matTooltip="Enable" matTooltipPosition="above">
          <mat-icon class="material-icons-outlined">radio_button_unchecked</mat-icon>
        </button>
        <button *ngIf="item?.disabled" mat-icon-button color="primary" (click)="delete(item.id)" matTooltip="Delete"
                matTooltipPosition="above">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>


